import { render, staticRenderFns } from "./consultar.vue?vue&type=template&id=22eba599&"
import script from "./consultar.vue?vue&type=script&lang=js&"
export * from "./consultar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports